import { css } from '@emotion/core';
import React from 'react';
import { black, gray6 } from 'styles/global_defaults/colors';
import {
  openSans,
  semiBoldFontWeight,
  textSmallFontSize,
} from 'styles/global_defaults/fonts';
import {
  halfSpacing,
  largeSpacing,
  threeQuartersSpacing,
} from 'styles/global_defaults/scaffolding';
import NvIcon from './nv-icon';

type BadgeProps = {
  color?: string;
  children: string;
  iconName?: string;
  borderColor?: string;
  backgroundColor?: string;
  Icon?: React.ComponentType<React.SVGProps<SVGElement>>;
};

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  (props, ref) => {
    const {
      Icon,
      children,
      iconName,
      color = black,
      backgroundColor = gray6,
      borderColor = backgroundColor,
      ...rest
    } = props;

    const styles = css`
      font-family: ${openSans};
      font-size: ${textSmallFontSize}px;
      font-weight: ${semiBoldFontWeight};
      padding: ${threeQuartersSpacing / 2}px ${halfSpacing}px;
      max-width: 100%;
      width: fit-content;
      height: ${largeSpacing}px;
      border: 1px solid ${borderColor};
      border-radius: ${largeSpacing / 2}px;
      color: ${color};
      background-color: ${backgroundColor};
      display: flex;
      align-items: center;

      svg,
      .icon {
        margin-right: ${halfSpacing}px;
      }

      span {
        flex: 1;
        text-transform: capitalize;
      }
    `;

    return (
      <div ref={ref} css={styles} {...rest}>
        {iconName && <NvIcon icon={iconName} size='xss-smallest' />}
        {Icon && <Icon width={16} height={16} />}
        <span>{children}</span>
      </div>
    );
  },
);

export default Badge;
